import { Injectable } from '@angular/core';
import * as moment from 'moment';

const DEFAULT_TIMEZONE = 'EST';

/**
 * A wrapper around moment.js, this service simplifies formatting of date and time values
 * by components that need to display them to the users. The default time zone is EST.
 */
@Injectable({
  providedIn: 'root'
})
export class DateHelperService {

  public formatStartDateAndTime(startDateString: string) {
    return moment(startDateString).format('ddd, MMMM D • hA');
  }

  public formatStartDate(startDateString) {
    return moment(startDateString).format('ddd, MMMM D');
  }

  public formatEndDateAndTime(startDateString: string, endDateString: string) {
    const start = moment(startDateString);
    const end = moment(endDateString);

    if (end.diff(start, 'day') >= 1) {
      return end.format('ddd, MMMM D • hA ') + DEFAULT_TIMEZONE;
    } else {
      return end.format('hA ') + DEFAULT_TIMEZONE;
    }
  }

  public formatEndDate(endDateString: string) {
    return moment(endDateString).format('ddd, MMMM D');
  }

  public isDateOnly(startDateString: string, endDateString: string): boolean {
    const start = moment(startDateString);
    const startDateOnly = start.clone();
    startDateOnly.startOf('day');

    if (start.diff(startDateOnly) !== 0) {
      return false;
    }

    if (!endDateString) {
      return true;
    }

    const end = moment(endDateString);

    if (end.diff(start, 'day') >= 1 || end.diff(start) === 0) {
      return true;
    }

    return false;
  }

  public getTimeline(rawStartDate: string, rawEndDate: string): string {
    if (!rawStartDate) {
      return null;
    }

    const isDateOnly = this.isDateOnly(rawStartDate, rawEndDate);
    let timeline: string = null;

    if (isDateOnly) {
      timeline = this.formatStartDate(rawStartDate);
    } else {
      timeline = this.formatStartDateAndTime(rawStartDate);
    }

    if (rawEndDate) {
      const end = (isDateOnly) ? this.formatEndDate(rawEndDate) :
        this.formatEndDateAndTime(rawStartDate, rawEndDate);
      timeline = timeline + ' to ' + end;
    }

    return timeline;
  }
}
